// extracted by mini-css-extract-plugin
export default {"container":"formForSend_container__kw7Ra","textareaContainer":"formForSend_textareaContainer__UNHxH"};